// extracted by mini-css-extract-plugin
export default {"App":"NewImageCropper_App__h9dwm","Crop-Controls":"NewImageCropper_Crop-Controls__nbJ-c","App_Image_Boundary_Dimensions":"NewImageCropper_App_Image_Boundary_Dimensions__jR-uI"};